.entrypoint {
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;
  margin-top: 0;
}

.entrypoint:hover {
  cursor: pointer;
}

.entrypoint__title {
  font-size: 15px;
}

.entrypoint__divider {
  background: var(--colors-grays-ultralight);
  height: 16px;
  margin-bottom: 24px;
  margin-left: -24px;
  margin-right: -24px;
}

.checkbox {
  color: var(--colors-text-main);
}

@media all and (--reefer-media-tablet-min) {
  .entrypoint {
    padding-bottom: 20px;
    margin-top: -20px;
  }

  .entrypoint__title {
    font-size: 20px;
  }

  .entrypoint__divider {
    margin-bottom: 40px;
    margin-left: -40px;
    margin-right: -40px;
  }
}
